// src/services/api.js
//const API_BASE_URL = 'http://localhost:8000';  // Update for production

const API_BASE_URL = 'https://api.codetrend.com/qreel';

export async function searchMovies(query, useQuantum = false) {
  try {
    const response = await fetch(`${API_BASE_URL}/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        use_quantum: useQuantum
      }),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to search movies');
    }
    
    return await response.json();
  } catch (error) {
    console.error('API Error:', error);
    
    // For development/demo purposes, return mock data when the API fails
    return getMockMovieData(query);
  }
}

// Mock data for development/demo purposes
function getMockMovieData(query) {
  const mockMovie = {
    id: 123,
    title: `Result for "${query}"`,
    overview: "This is a mock movie overview. The API call failed, so we're showing this placeholder data instead. In a real application, this would contain information about the movie's plot, setting, and main characters.",
    poster_path: null,
    backdrop_path: null,
    release_date: "2023-01-01",
    runtime: 120,
    genres: ["Action", "Drama"],
    vote_average: 7.5,
    budget: 100000000,
    revenue: 250000000,
    cast: [
      { name: "Actor 1", character: "Character 1", profile_path: null },
      { name: "Actor 2", character: "Character 2", profile_path: null },
      { name: "Actor 3", character: "Character 3", profile_path: null }
    ],
    crew: [
      { name: "Director", job: "Director", profile_path: null },
      { name: "Writer", job: "Screenplay", profile_path: null }
    ],
    summary: "This is a mock summary generated when the API call fails. In a real application, this would be an AI-generated summary of the movie.",
    dialogues: [
      { character: "Character 1", quote: "Mock dialogue 1", context: "Scene context" },
      { character: "Character 2", quote: "Mock dialogue 2", context: "Scene context" }
    ],
    search_info: {
      original_query: query,
      refined_query: query,
      intent_type: "title"
    }
  };

  const similarMovies = [
    { id: 124, title: "Similar Movie 1", poster_path: null, release_date: "2022-01-01", similarity_score: 0.9 },
    { id: 125, title: "Similar Movie 2", poster_path: null, release_date: "2021-01-01", similarity_score: 0.8 },
    { id: 126, title: "Similar Movie 3", poster_path: null, release_date: "2020-01-01", similarity_score: 0.7 }
  ];

  return { movie: mockMovie, similar_movies: similarMovies };
}